import React from 'react'

const SuccessfulAuctions = () => {
  return (
    <div>SuccessfulAuctions</div>
  )
}

export default SuccessfulAuctions